import Vue from 'vue'
import Router from 'vue-router'

//一级路由
//无需按需加载
import Index from '../views/admin-index/Index'

//webpack按需加载
//首页
const Dashboard = r => require.ensure([], () => r(require('../views/admin-index/dashboard/Dashboard')), 'Dashboard')
//结算
const StatementAccount = r => require.ensure([], () => r(require('../views/settlement/StatementAccount')), 'StatementAccount')
const DealFlow = r => require.ensure([], () => r(require('../views/settlement/DealFlow')), 'DealFlow')
const Refund = r => require.ensure([], () => r(require('../views/settlement/Refund')), 'Refund')
const AccountsPayable = r => require.ensure([], () => r(require('../views/settlement/AccountsPayable')), 'AccountsPayable')
const AccountsReceivable = r => require.ensure([], () => r(require('../views/settlement/AccountsReceivable')), 'AccountsReceivable')
const Obligation = r => require.ensure([], () => r(require('../views/settlement/Obligation')), 'Obligation')
const SettlementIndex = r => require.ensure([], () => r(require('../views/settlement/SettlementIndex')), 'SettlementIndex')



Vue.use(Router)
const router = new Router({
  mode: "history",
  routes: [
    {
      path: '*',//输错路由回首页
      redirect: '/manage/404',
      meta: {
        keepAlive: false,
        page: '输错路由回首页',
        level: 0
      }
    },
    {
      path: '/',//默认路由
      redirect: '/login',
      meta: {
        keepAlive: false,
        page: '默认路由',
        level: 0
      }
    },
    //登录
    {
      path: '/login',
      name: 'login',
      component: r => require.ensure([], () => r(require('../views/login/Login')), 'Login'),
      meta: {
        keepAlive: false,
        page: '登录',
        level: 0
      }
    },
    //找回密码
    {
      path: '/forgotPassword',
      name: 'forgotPassword',
      component: r => require.ensure([], () => r(require('../views/forgot-password/ForgotPassword')), 'ForgotPassword'),
      meta: {
        keepAlive: false,
        page: '找回密码',
        level: 0
      }
    },
    //404
    {
      path: '/manage/404',
      name: 'notFound',
      component: r => require.ensure([], () => r(require('../views/error/NotFound')), 'NotFound'),
      meta: {
        keepAlive: false,
        page: '404',
        level: 0
      }
    },
    //主页-所有模块
    {
      path: '/manage/dashboard',
      name: 'manage',
      component: Index,
      children: [
        {
          path: '/manage/dashboard',
          name: 'dashboard',
          component: Dashboard,
          meta: {//缓存、路由元信息、元字段
            keepAlive: false,
            page: '仪表板',
            //requiresAuth: true,
            level: 0
          }
        },
        {
          path: '/manage/messageManageList',
          name: 'messageManageList',
          component: r => require.ensure([], () => r(require('../views/system-manage/message-manage/message-list/MessageManageList')), 'MessageManageList'),
          meta: {
            keepAlive: true,
            page: '系统管理-消息管理-列表',
            level: 1
          }
        },
        {
          path: '/manage/messageManageList/messageHandle',
          name: 'messageHandle',
          component: r => require.ensure([], () => r(require('../views/system-manage/message-manage/message-handle/MessageHandle')), 'MessageHandle'),
          meta: {
            keepAlive: false,
            page: '系统管理-消息管理-通知、公告',
            level: 2
          }
        },
        {
          path: '/manage/messageManageList/messageDetail',
          name: 'messageDetail',
          component: r => require.ensure([], () => r(require('../views/system-manage/message-manage/MessageDetail')), 'MessageDetail'),
          meta: {
            keepAlive: false,
            page: '系统管理-消息管理-详情',
            level: 2
          }
        },
        //会员管理
        {
          path: '/manage/memberAuditList',
          name: 'memberAuditList',
          component: r => require.ensure([], () => r(require('../views/member-audit/member-audit-list/MemberAuditList')), 'MemberAuditList'),
          meta: {
            keepAlive: true,
            page: '会员管理',
            level: 1
          }
        },
        {
          path: '/manage/memberAuditList/memberAudit',
          name: 'memberAudit',
          component: r => require.ensure([], () => r(require('../views/member-audit/MemberAudit')), 'MemberAudit'),
          meta: {
            keepAlive: false,
            page: '会员管理-会员审核',
            level: 2
          }
        },
        {
          path: '/manage/memberAuditList/memberAuditDetail',
          name: 'memberAuditDetail',
          component: r => require.ensure([], () => r(require('../views/member-audit/MemberAuditDetail')), 'MemberAuditDetail'),
          meta: {
            keepAlive: false,
            page: '会员管理-会员审核-查看审核',
            level: 2
          }
        },
        {
          path: '/manage/auctionTargetList',
          name: 'auctionTargetList',
          component: r => require.ensure([], () => r(require('../views/quality-control/auction-good/auction-target-manage/AuctionTargetList')), 'AuctionTargetList'),
          meta: {
            keepAlive: true,
            page: '标的列表',
            level: 1
          }
        },
        {
          path: '/manage/auctionTarget/detectionItemList',
          name: 'detectionItemList',
          component: r => require.ensure([], () => r(require('../views/quality-control/auction-good/detection-item-manage/DetectionItemList')), 'DetectionItemList'),
          meta: {
            keepAlive: false,
            page: '标的-检测项',
            level: 2
          }
        },
        {
          path: '/manage/auctionTarget/flawList',
          name: 'flawList',
          component: r => require.ensure([], () => r(require('../views/quality-control/auction-good/flaw-manage/FlawList')), 'FlawList'),
          meta: {
            keepAlive: false,
            page: '标的-瑕疵管理',
            level: 2
          }
        },
        {
          path: '/manage/auctionTarget/specsList',
          name: 'specsList',
          component: r => require.ensure([], () => r(require('../views/quality-control/auction-good/specs-manage/SpecsList')), 'SpecsList'),
          meta: {
            keepAlive: false,
            page: '标的-规格管理',
            level: 2
          }
        },
        {
          path: '/manage/auctionTarget/classifyList',
          name: 'classifyList',
          component: r => require.ensure([], () => r(require('../views/quality-control/auction-good/classify-manage/ClassifyList')), 'ClassifyList'),
          meta: {
            keepAlive: false,
            page: '标的-分类管理',
            level: 2
          }
        },
        {
          path: '/manage/qualityControlList',
          name: 'qualityControlList',
          component: r => require.ensure([], () => r(require('../views/quality-control/quality-control-manage/quality-control-manage/quality-control-list/QualityControlList')), 'QualityControlList'),
          meta: {
            keepAlive: true,
            page: '质检-质检管理-质检管理',
            level: 1
          }
        },
        {
          path: '/manage/qualityControlList/uploadReport',
          name: 'uploadReport',
          component: r => require.ensure([], () => r(require('../views/quality-control/quality-control-manage/quality-control-manage/UploadReport')), 'UploadReport'),
          meta: {
            keepAlive: false,
            page: '质检-质检管理-上传报告',
            level: 2
          }
        },
        {
          path: '/manage/qualityControlList/examineReport',
          name: 'examineReport',
          component: r => require.ensure([], () => r(require('../views/quality-control/quality-control-manage/quality-control-manage/ExamineReport')), 'ExamineReports'),
          meta: {
            keepAlive: false,
            page: '质检-质检管理-审核',
            level: 2
          }
        },
        {
          path: '/manage/qualityControlList/showReport',
          name: 'showReport',
          component: r => require.ensure([], () => r(require('../views/quality-control/quality-control-manage/quality-control-manage/ShowReport')), 'ShowReport'),
          meta: {
            keepAlive: false,
            page: '质检-质检管理-查看',
            level: 2
          }
        },
        {
          path: '/manage/setMealList',
          name: 'setMealList',
          component: r => require.ensure([], () => r(require('../views/quality-control/setmeal-manage/SetMealList')), 'SetMealList'),
          meta: {
            keepAlive: true,
            page: '质检-质检套餐',
            level: 1
          }
        },
        {
          path: '/manage/setMealList/addedEditorHandle',
          name: 'addedEditorHandle',
          component: r => require.ensure([], () => r(require('../views/quality-control/setmeal-manage/AddedEditorHandle')), 'AddedEditorHandle'),
          meta: {
            keepAlive: false,
            page: '质检-质检套餐-新增或者修改',
            level: 2
          }
        },
        {
          path: '/manage/setMealList/examineHandle',
          name: 'examineHandle',
          component: r => require.ensure([], () => r(require('../views/quality-control/setmeal-manage/ExamineHandle')), 'ExamineHandle'),
          meta: {
            keepAlive: false,
            page: '质检-质检套餐-审核',
            level: 2
          }
        },
        //仓储物流
        {
          path: '/manage/storehouseManageList',
          name: 'storehouseManageList',
          component: r => require.ensure([], () => r(require('../views/warehouse-logistics/basic-data/storehouse-manage/StorehouseManageList')), 'StorehouseManageList'),
          meta: {
            keepAlive: false,
            page: '仓储物流-基础资料-仓库资料',
            level: 0
          }
        },
        {
          path: '/manage/warehouseManageList',
          name: 'warehouseManageList',
          component: r => require.ensure([], () => r(require('../views/warehouse-logistics/basic-data/warehouse-manage/WarehouseManageList')), 'WarehouseManageList'),
          meta: {
            keepAlive: false,
            page: '仓储物流-基础资料-库区管理',
            level: 0
          }
        },
        {
          path: '/manage/sinkData',
          name: 'sinkData',
          component: r => require.ensure([], () => r(require('../views/warehouse-logistics/basic-data/sink-data-manage/SinkData')), 'SinkData'),
          meta: {
            keepAlive: false,
            page: '仓储物流-基础资料-库位资料',
            level: 0
          }
        },
        {
          path: '/manage/packingMaterialList',
          name: 'packingMaterialList',
          component: r => require.ensure([], () => r(require('../views/warehouse-logistics/basic-data/packing-material/PackingMaterialList')), 'PackingMaterialList'),
          meta: {
            keepAlive: false,
            page: '仓储物流-基础资料-包材资料',
            level: 0
          }
        },
        {
          path: '/manage/packingManageList',
          name: 'packingManageList',
          component: r => require.ensure([], () => r(require('../views/warehouse-logistics/basic-data/packing-manage/PackingManageList')), 'PackingManageList'),
          meta: {
            keepAlive: false,
            page: '仓储物流-基础资料-包材管理',
            level: 0
          }
        },
        // 新增--货物委托
        {
          path: '/manage/goodsEntrustManageList',
          name: 'goodsEntrustManageList',
          component: r => require.ensure([], () => r(require('../views/warehouse-logistics/take-manage/goods-entrust/TakeManageList')), 'TakeManageList'),
          meta: {
            keepAlive: true,
            page: '仓储物流-收货管理-货物委托',
            level: 1
          }
        },
        {
          path: '/manage/goodsEntrustManage/OrderDetail',
          name: 'OrderDetail',
          component: r => require.ensure([], () => r(require('../views/warehouse-logistics/take-manage/goods-entrust/OrderDetail')), 'OrderDetail'),
          meta: {
            keepAlive: true,
            page: '仓储物流-收货管理-货物委托详情',
            level: 1
          }
        },
        // 新增结束--货物委托
        {
          path: '/manage/entrustManageList',
          name: 'entrustManageList',
          component: r => require.ensure([], () => r(require('../views/warehouse-logistics/receiving-manage/entrust-manage/entrust-manage-list/EntrustManageList')), 'EntrustManageList'),
          meta: {
            keepAlive: true,
            page: '仓储物流-收货管理-委托管理',
            level: 1
          }
        },
        {
          path: '/manage/entrustManageList/contractAdded',
          name: 'contractAdded',
          component: r => require.ensure([], () => r(require('../views/warehouse-logistics/receiving-manage/entrust-manage/ContractAdded')), 'ContractAdded'),
          meta: {
            keepAlive: false,
            page: '仓储物流-收货管理-合同明细补充',
            level: 2
          }
        },
        {
          path: '/manage/entrustManageList/viewOrder',
          name: 'viewOrder',
          component: r => require.ensure([], () => r(require('../views/warehouse-logistics/receiving-manage/entrust-manage/ViewOrder')), 'ViewOrder'),
          meta: {
            keepAlive: false,
            page: '仓储物流-收货管理-查看委托单',
            level: 2
          }
        },
        {
          path: '/manage/appointmentManageList',
          name: 'appointmentManageList',
          component: r => require.ensure([], () => r(require('../views/warehouse-logistics/receiving-manage/appointment-manage/appointment-list/AppointmentManageList')), 'AppointmentManageList'),
          meta: {
            keepAlive: true,
            page: '仓储物流-收货管理-预约管理',
            level: 1
          }
        },
        {
          path: '/manage/appointmentManageList/entrustedRecord',
          name: 'entrustedRecord',
          component: r => require.ensure([], () => r(require('../views/warehouse-logistics/receiving-manage/appointment-manage/EntrustedRecord')), 'EntrustedRecord'),
          meta: {
            keepAlive: false,
            page: '仓储物流-收货管理-委托录单',
            level: 2
          }
        },
        {
          path: '/manage/initialInspectionList',
          name: 'initialInspectionList',
          component: r => require.ensure([], () => r(require('../views/warehouse-logistics/receiving-manage/initial-inspection/InitialInspectionList')), 'InitialInspectionList'),
          meta: {
            keepAlive: false,
            page: '仓储物流-收货管理-初检任务受理',
            level: 0
          }
        },
        {
          path: '/manage/entrustManageList/auditEntrusted',
          name: 'auditEntrusted',
          component: r => require.ensure([], () => r(require('../views/warehouse-logistics/receiving-manage/entrust-manage/AuditEntrusted')), 'AuditEntrusted'),
          meta: {
            keepAlive: false,
            page: '仓储物流-收货管理-审核委托',
            level: 2
          }
        },
        {
          path: '/manage/entrustManageList/printReceipt',
          name: 'printReceipt',
          component: r => require.ensure([], () => r(require('../views/warehouse-logistics/receiving-manage/entrust-manage/PrintReceipt')), 'PrintReceipt'),
          meta: {
            keepAlive: false,
            page: '仓储物流-收货管理-打印收货单'
          }
        },
        {
          path: '/manage/taskReceivingList',
          name: 'taskReceivingList',
          component: r => require.ensure([], () => r(require('../views/warehouse-logistics/move-library-manage/task-receiving/task-receiving-list/TaskReceivingList')), 'TaskReceivingList'),
          meta: {
            keepAlive: true,
            page: '仓储物流-移库管理-任务接收',
            level: 1
          }
        },
        {
          path: '/manage/taskReceivingList/taskReceivingDetail',
          name: 'taskReceivingDetail',
          component: r => require.ensure([], () => r(require('../views/warehouse-logistics/move-library-manage/task-receiving/task-receiving-detail/TaskReceivingDetail')), 'TaskReceivingDetail'),
          meta: {
            keepAlive: false,
            page: '仓储物流-移库管理-任务接收-阅读',
            level: 2
          }
        },
        {
          path: '/manage/moveLibraryTaskList',
          name: 'moveLibraryTaskList',
          component: r => require.ensure([], () => r(require('../views/warehouse-logistics/move-library-manage/move-library-task/move-library-task-list/MoveLibraryTaskList')), 'MoveLibraryTaskList'),
          meta: {
            keepAlive: true,
            page: '仓储物流-移库管理-移库任务',
            level: 1
          }
        },
        {
          path: '/manage/moveLibraryTaskList/moveLibraryTaskDetail',
          name: 'moveLibraryTaskDetail',
          component: r => require.ensure([], () => r(require('../views/warehouse-logistics/move-library-manage/move-library-task/move-library-task-detail/MoveLibraryTaskDetail')), 'MoveLibraryTaskDetail'),
          meta: {
            keepAlive: false,
            page: '仓储物流-移库管理-移库任务详情',
            level: 2
          }
        },
        {
          path: '/manage/confirmAuditList',
          name: 'confirmAuditList',
          component: r => require.ensure([], () => r(require('../views/warehouse-logistics/move-library-manage/confirm-audit/confirm-audit-list/ConfirmAuditList')), 'ConfirmAuditList'),
          meta: {
            keepAlive: true,
            page: '仓储物流-移库管理-确认审核',
            level: 1
          }
        },
        {
          path: '/manage/confirmAuditList/confirmAuditDetail',
          name: 'confirmAuditDetail',
          component: r => require.ensure([], () => r(require('../views/warehouse-logistics/move-library-manage/confirm-audit/confirm-audit-detail/ConfirmAuditDetail')), 'ConfirmAuditDetail'),
          meta: {
            keepAlive: false,
            page: '仓储物流-移库管理-确认审核-查看',
            level: 2
          }
        },
        {
          path: '/manage/inventoryQueryList',
          name: 'inventoryQueryList',
          component: r => require.ensure([], () => r(require('../views/warehouse-logistics/inventory-manage/inventory-query/inventory-query-list/InventoryQueryList')), 'InventoryQueryList'),
          meta: {
            keepAlive: true,
            page: '仓储物流-库存管理-库存查询',
            level: 1
          }
        },
        {
          path: '/manage/inventoryQueryList/inventoryQueryDetail',
          name: 'inventoryQueryDetail',
          component: r => require.ensure([], () => r(require('../views/warehouse-logistics/inventory-manage/inventory-query/InventoryQueryDetail')), 'InventoryQueryDetail'),
          meta: {
            keepAlive: false,
            page: '仓储物流-库存管理-库存详情',
            level: 2
          }
        },
        {
          path: '/manage/inventoryCheckList',
          name: 'inventoryCheckList',
          component: r => require.ensure([], () => r(require('../views/warehouse-logistics/inventory-manage/inventory-check/InventoryCheckList')), 'InventoryCheckList'),
          meta: {
            keepAlive: false,
            page: '仓储物流-库存管理-库存盘点',
            level: 0
          }
        },
        {
          path: '/manage/earningsLossesList',
          name: 'earningsLossesList',
          component: r => require.ensure([], () => r(require('../views/warehouse-logistics/inventory-manage/earnings-losses/EarningsLossesList')), 'EarningsLossesList'),
          meta: {
            keepAlive: false,
            page: '仓储物流-库存管理-盘盈亏审核',
            level: 0
          }
        },
        {
          path: '/manage/shipmentManageList',
          name: 'shipmentManageList',
          component: r => require.ensure([], () => r(require('../views/warehouse-logistics/out-stock-manage/shipment-manage/shipment-list/ShipmentManageList')), 'ShipmentManageList'),
          meta: {
            keepAlive: true,
            page: '仓储物流-出库管理-出货单管理',
            level: 1
          }
        },
        {
          path: '/manage/shipmentManageList/shipmentDetail',
          name: 'shipmentDetail',
          component: r => require.ensure([], () => r(require('../views/warehouse-logistics/out-stock-manage/shipment-manage/shipment-detail/ShipmentDetail')), 'ShipmentDetail'),
          meta: {
            keepAlive: false,
            page: '仓储物流-库存管理-出库管理-出货单详情',
            level: 2
          }
        },
        {
          path: '/manage/shipmentManageList/shipmentApproval',
          name: 'shipmentApproval',
          component: r => require.ensure([], () => r(require('../views/warehouse-logistics/out-stock-manage/shipment-manage/shipment-approval/ShipmentApproval')), 'ShipmentApproval'),
          meta: {
            keepAlive: false,
            page: '仓储物流-库存管理-出库管理-出货单审批',
            level: 2
          }
        },
        {
          path: '/manage/shipmentManageList/manualDepot',
          name: 'manualDepot',
          component: r => require.ensure([], () => r(require('../views/warehouse-logistics/out-stock-manage/shipment-manage/manual-depot/ManualDepot')), 'ManualDepot'),
          meta: {
            keepAlive: false,
            page: '仓储物流-库存管理-出库管理-手动出库',
            level: 2
          }
        },
        // 结算
        {
          path: '/settlement/settlementIndex',
          name: 'SettlementIndex',
          component: SettlementIndex,
          meta: {
            keepAlive: false,
            page: '结算功能'
          }
        },
        {
          path: '/settlement/statementAccount',
          name: 'StatementAccount',
          component: StatementAccount,
          meta: {
            keepAlive: false,
            page: '首页-对账单'
          }
        },
        {
          path: '/settlement/dealFlow',
          name: 'DealFlow',
          component: DealFlow,
          meta: {
            keepAlive: false,
            page: '首页-交易流水'
          }
        },
        {
          path: '/settlement/refund',
          name: 'Refund',
          component: Refund,
          meta: {
            keepAlive: false,
            page: '首页-退款'
          }
        },
        {
          path: '/settlement/accountsPayable',
          name: 'AccountsPayable',
          component: AccountsPayable,
          meta: {
            keepAlive: false,
            page: '首页-应付款'
          }
        },
        {
          path: '/settlement/accountsReceivable',
          name: 'AccountsReceivable',
          component: AccountsReceivable,
          meta: {
            keepAlive: false,
            page: '首页-应收款'
          }
        },
        {
          path: '/settlement/obligation',
          name: 'Obligation',
          component: Obligation,
          meta: {
            keepAlive: false,
            page: '首页-暂收代付款'
          }
        },
        // 撤标管理
        {
          path: '/auction-function/reviewMark',
          name: 'reviewMark',
          component: r => require.ensure([], () => r(require('../views/auction-function//ReviewMark/ReviewMark.vue')), 'ReviewMark'),
          meta: {
            keepAlive: false,
            page: '首页-撤标管理'
          }
        },
        // 拍卖
        {
          path: '/auction-function/auctionIndex',
          name: 'auctionIndex',
          component: r => require.ensure([], () => r(require('../views/auction-function/AuctionIndex')), 'AuctionIndex'),
          meta: {
            keepAlive: true,
            page: '首页-拍卖管理',
            level: 1
          }
        },
        {
          path: '/auction-function/pushAuction',
          name: 'pushAuction',
          component: r => require.ensure([], () => r(require('../views/auction-function/PushAuction/PushAuction')), 'PushAuction'),
          meta: {
            keepAlive: false,
            page: '首页-发布拍卖',
            level: 2
          }
        },
        {
          path: '/auction-function/LookGoodsPage',
          name: 'lookGoodsPage',
          component: r => require.ensure([], () => r(require('../views/auction-function/LookGoodsPage')), 'LookGoods'),
          meta: {
            keepAlive: false,
            page: '首页-查看预约',
            level: 2
          }
        },
        {
          path: '/auction-function/auditAuctionIndex',
          name: 'auditAuctionIndex',
          component: r => require.ensure([], () => r(require('../views/auction-function/AuditAuction/AuditAuctionIndex.vue')), 'AuditAuctionIndex'),
          meta: {
            keepAlive: true,
            page: '首页-审核拍卖主页',
            level: 1
          }
        },
        {
          path: '/auction-function/auditAuction',
          name: 'auditAuction',
          component: r => require.ensure([], () => r(require('../views/auction-function/AuditAuction/AuditAuction')), 'AuditAuction'),
          meta: {
            keepAlive: false,
            page: '首页-审核拍卖',
            level: 2
          }
        },
        {
          path: '/auction-function/auctionAdminNot',
          name: 'auctionAdminNot',
          component: r => require.ensure([], () => r(require('../views/auction-function/AuctionCheck/AuctionAdminNot')), 'AuctionAdminNot'),
          meta: {
            keepAlive: false,
            page: '首页-拍卖管理-未公示',
            level: 2
          }
        },
        {
          path: '/auction-function/auctionAdminStart',
          name: 'auctionAdminStart',
          component: r => require.ensure([], () => r(require('../views/auction-function/AuctionCheck/AuctionAdminStart')), 'AuctionAdminStart'),
          meta: {
            keepAlive: false,
            page: '首页-拍卖管理-公示中'
          }
        },
        {
          path: '/auction-function/auctionAdminAuction',
          name: 'auctionAdminAuction',
          component: r => require.ensure([], () => r(require('../views/auction-function/AuctionCheck/AuctionAdminAuction')), 'AuctionAdminAuction'),
          meta: {
            keepAlive: false,
            page: '首页-拍卖管理-拍卖中'
          }
        },
        {
          path: '/auction-function/auctionResultConfirm',
          name: 'auctionResultConfirm',
          component: r => require.ensure([], () => r(require('../views/auction-function/AuctionResultConfirm/AuctionResultConfirm.vue')), 'AuctionResultConfirm'),
          meta: {
            keepAlive: false,
            page: '首页-拍卖管理-竞拍结果确认',
            level: 2
          }
        },
        // 大屏控制
        {
          path: '/screen-control/control',
          name: 'screenControl',
          component: r => require.ensure([], () => r(require('../views/screen-control/ScreenControl.vue')), 'ScreenControl'),
          meta: {
            keepAlive: false,
            page: '大屏控制',
            level: 0
          }
        },
        {
          path: '/screen-control/screenPage',
          name: 'screenPage',
          component: r => require.ensure([], () => r(require('../views/screen-control/components/ScreenPage.vue')), 'ScreenPage'),
          meta: {
            keepAlive: false,
            page: '大屏数据显示',
            level: 0
          }
        },
        {
          path: '/screen-control/screenControlPage',
          name: 'screenControlPage',
          component: r => require.ensure([], () => r(require('../views/screen-control/ScreenControlPage.vue')), 'ScreenControlPage'),
          meta: {
            keepAlive: false,
            page: '大屏数据显示',
            level: 0
          }
        },
        {
          path: '/manage/orderManage/transactionOrderList',
          name: 'transactionOrderList',
          component: r => require.ensure([], () => r(require('../views/order-manage/transaction-order/transaction-order-list/TransactionOrderList')), 'TransactionOrderList'),
          meta: {
            keepAlive: false,
            page: '订单管理-成交订单管理-列表',
            level: 0
          }
        }
      ]
    }
  ]
})

//全局路由守卫、路由拦截
router.beforeEach((to, from, next) => {
  const isLogin = localStorage.token ? true : false;
  if (to.path === '/login' || to.path === '/forgotPassword') {
    next();
  } else {
    isLogin ? next() : next('/');
  }
})

//vue-router的错误处理函数 onError 捕获错误
router.onError((error) => {
  const pattern = /Loading chunk (\d)+ failed/g;
  const isChunkLoadFailed = error.message.match(pattern);
  const targetPath = router.history.pending.fullPath;
  if (isChunkLoadFailed) {
    router.replace(targetPath);
  }
});
export default router;



// WEBPACK FOOTER //
// ./src/router/index.js